/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Headline_Conversation_RecordedInputs */

const en_case_history_headline_conversation_recorded = /** @type {(inputs: Case_History_Headline_Conversation_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message received from`)
};

const pt_br2_case_history_headline_conversation_recorded = /** @type {(inputs: Case_History_Headline_Conversation_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagem recebida de`)
};

/**
* | output |
* | --- |
* | "Message received from" |
*
* @param {Case_History_Headline_Conversation_RecordedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_headline_conversation_recorded = /** @type {((inputs?: Case_History_Headline_Conversation_RecordedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Headline_Conversation_RecordedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_headline_conversation_recorded(inputs)
	return pt_br2_case_history_headline_conversation_recorded(inputs)
});